import { app } from '../../app.module'
/**
 * アカウントフォロワー増減
 * @class AccountFollowerUpDownCtrl
 */
class AccountFollowerUpDownCtrl {}

app.component('accountFollowerUpDown', {
  bindings: {
    followersUpDownRate: '<',
    followersStart: '<',
    followersEnd: '<',
  },
  template: require('./account-follower-up-down.pug')(),
  controller: AccountFollowerUpDownCtrl,
})
